import { z } from "zod";
import { authenticationResponseJSONSchema } from "../schemas.js";

export default {
  params: z.object({
    webAuthnAuthenticationResponse: authenticationResponseJSONSchema,
  }),
  response: z.object({
    token: z.string(),
  }),
};
